import {Injectable} from "@angular/core";
import {SatelliteDroparea, PayloadConfig} from "satellite-droparea";


@Injectable()
export class SatelliteService {
  instance: SatelliteDroparea | null = {} as SatelliteDroparea;
  init = false;

  get isInit(): boolean {
    return this.init;
  }

  create(payload: PayloadConfig) {
    this.instance = new SatelliteDroparea(payload);
    this.init = true;
  }

  destroy() {
    this.instance = null;
  }
}
